/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import {FC} from 'react'
import {Routes, Route, BrowserRouter, Navigate} from 'react-router-dom'
import {PrivateRoutes} from './PrivateRoutes'
import {ErrorsPage} from '../modules/errors/ErrorsPage'
import {Logout, AuthPage, useAuth} from '../modules/auth'
import {App} from '../App'
import {getHomePath} from '../utils/homePath'
import { RelatorioPage } from '../modules/relatoriosPage/RelatorioPage'
import { CheckoutPage } from '../pages/checkout/CheckoutPage'
import { CardPaymentPage } from '../pages/checkout/CardPaymentPage'
import { CheckoutSuccess } from '../pages/checkout/CheckoutSuccess'
import { KioskPage } from '../modules/kiosk/KioskPage'

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const {PUBLIC_URL} = process.env

const AppRoutes: FC = () => {
  const {auth, currentUser} = useAuth()
  const homePath = getHomePath(currentUser?.role?.slug)

  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <Routes>
        <Route element={<App />}>
          <Route path='checkout/:token/success' element={<CheckoutSuccess />} />
          <Route path='checkout/:token/pagamento' element={<CardPaymentPage />} />
          <Route path='checkout/:token/*' element={<CheckoutPage />} />
          <Route path='relatorio/*' element={<RelatorioPage />} />
          <Route path='kiosk' element={<KioskPage />} />
          <Route path='error/*' element={<ErrorsPage />} />
          <Route path='logout' element={<Logout />} />
          {auth ? (
            <>
              <Route path='/*' element={<PrivateRoutes />} />
              <Route index element={<Navigate to={homePath} />} />
              {/* <Route index element={<Navigate to='/portals' />} />
              <Route index element={<Navigate to='/filiais' />} /> */}
            </>
          ) : (
            <>
              <Route path='auth/*' element={<AuthPage />} />
              <Route path='*' element={<Navigate to='/auth' />} />
            </>
          )}
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export {AppRoutes}
